import styles from "../usersManagement/user_management_styles.module.scss";

const ROWS = 10;
const COLUMNS = 16;

const CompletedTransfersV2TableShimmer = () => {
  return (
    <tbody className={styles.table_body}>
      {Array.from({ length: ROWS }).map((_, rowIdx) => (
        <tr key={`completed-transfer-v2-row-${rowIdx}`}>
          {Array.from({ length: COLUMNS }).map((_, colIdx) => (
            <td key={`completed-transfer-v2-cell-${rowIdx}-${colIdx}`}>
              <div
                className={`${styles["shimmer"]} ${styles["shimmer-cell"]}`}
              />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};

export default CompletedTransfersV2TableShimmer;
